import React, { useState, useEffect, useMemo } from 'react'
import ReactGA from 'react-ga'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { Row, Col, Container } from 'react-bootstrap'
import moment from 'moment'
import _ from 'lodash'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'

import momenttz from '../../../helpers/momenttz'
import AvailableDatesNav from '../DailyEvents/AvailableDatesNav'
import EventsTable from '../DailyEvents/EventsTable'
import TripsGrid from '../TripsHistory/TripsGrid'
import EventVideoRequestModal from '../../modals/EventVideoRequestModal'

import { getAvailableDatesOfDevice, getEventsOfCompanyAndRange } from '../../../../action/AlertActions'

import './VehicleSidebar.sass'
import { isMobileOnly } from 'react-device-detect'

const VehicleSidebar = (props) => {

	const [interval, setIntervalState] = useState(null);

	const { user, company, _map, showTripsHistory, setShowTripsHistory, activeTreeItem, onClickPlayback, toggleLoader } = props;
	const userRole = user.roles[0];

	const [state, setState] = useState({
		eventDate: momenttz(),
		availableDates: [],
		events: [],
		page: 1,
		sizePerPage: 10,
		totalSize: 0,
		showVideoRequest: false,
		requestedEventIDs: [],
		filters: {
			critical_gsensor: true,
			speed: true,
			driver: true,
			custom: true,
			pending: false,
			harshaccel: true,
			harshbraking: true,
			adas_fcw: true,
			adas_ldw: true,
			adas_pcw: true,
			adas_hw: true,
			tailgating: true,
			distraction: true,
			drowsiness: true,
			phone_use: true,
			yawning: true,
			seatbelt: true,
			smoking: true
		},
	})

	// useEffect(() => {
	// 	console.log('!!!componentDidMount VehicleSidebar props: ', props);

	// 	getAvailableDates(() => {
	// 		if (state.availableDates.length) {
	// 			setState({ ...state, eventDate: state.availableDates[state.availableDates.length - 1] })
	// 			getFleetEvents()
	// 		} else {
	// 			toggleLoader(false);
	// 			setState({ ...state, events: [] })
	// 		}
	// 	})
	// }, [])

	useEffect(() => {
		// debugger
		if (!showTripsHistory) {
			getAvailableDates()
			// getAvailableDates(() => {
			// 	if (state.availableDates.length) {
			// 		setState({ ...state, eventDate: state.availableDates[state.availableDates.length - 1] })
			// 		getFleetEvents()
			// 	} else {
			// 		toggleLoader(false)
			// 		setState({ ...state, events: [] })
			// 	}
			// },
			// 	activeTreeItem.device_id)
		}

		return () => clearTimer();
	}, [activeTreeItem.device_id, showTripsHistory])

	useEffect(() => {
		// debugger
		if (state.availableDates.length) {
			const new_event_date = state.availableDates[state.availableDates.length - 1]
			setState((prevState) => { return { ...prevState, eventDate: new_event_date } })
			getFleetEvents(state.page, state.sizePerPage, true, new_event_date)
		}
		// else {
		// 	toggleLoader(false);
		// 	toastr.info('', 'No events available for this company')
		// }
		// }, [state.availableDates.length])
	}, [state.availableDates])

	const getAvailableDates = (callback, argDeviceId = null) => {
		const data = {
			device_id: argDeviceId || activeTreeItem.device_id,
			start_ts: '20150101000000',
		};
		getAvailableDatesOfDevice(data)
			.then(async (res, err) => {
				// console.log('!getAvailableDatesOfDevice res: ', res, err);
				const response = await res.data.response.events_dates
				// setState({ ...state, availableDates: response })
				setState((prevState) => { return { ...prevState, availableDates: response } })
				if (callback && typeof callback === 'function') {
					callback();
				}
			})
			.catch((error) => {
				console.log('!getAvailableDatesOfDevice error: ', error.response, error);

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const getFleetEvents = (page = state.page, sizePerPage = state.sizePerPage, showLoader = true, argEventDate = null, company_name = null, callback = null, eventIds = null) => {
		const { user, company, activeTreeItem } = props
		const paramEventDate = argEventDate || state.eventDate
		const data = {
			user_role: userRole,
			company_name: company.name || user.company_name,
			partner_name: company.partner,
			start_ts: momenttz(moment(paramEventDate).format('YYYY-MM-DD 00:00:00')).utc().format('YYYYMMDDHHmmss'),
			end_ts: momenttz(moment(paramEventDate).format('YYYY-MM-DD 23:59:59')).utc().format('YYYYMMDDHHmmss'),
			page_number: page,
			page_size: sizePerPage,
			filters: getFilters(),
			search_type: 'deviceid',
			search: activeTreeItem.device_id,
			event_ids: eventIds,
		}

		if (eventIds) {
			delete data.page_number
			delete data.page_size
		}

		if (showLoader) {
			toggleLoader(true)
		}

		getEventsOfCompanyAndRange(data)
			.then((res, err) => {
				// console.log('!getEventsOfCompanyAndRange res: ', res, err)
				const { response } = res.data

				if (eventIds && eventIds.length) {
					if (response.events.length) {
						const filteredEvents = state.events.map((event) => {
							const index = eventIds.indexOf(event.id);
							if (index > -1) {
								const obj = _.find(response.events, ['id', event.id]); // res.data.response.events[0];
								if (obj
									&& ((obj.uploading_status === 'VIDEO_UPLOADED'
										&& obj.snapshot_status === 'SNAPSHOT_UPLOADED')
										|| obj.uploading_status === 'VIDEO_NON_EXIST'
									)
								) {
									let requestedEventIDs = state.requestedEventIDs;
									requestedEventIDs.splice(index, 1);
									// setState({ ...state, requestedEventIDs: requestedEventIDs });
									setState((prevState) => { return { ...prevState, requestedEventIDs } })
									return obj
								}
							}

							return event
						})
						// setState({ ...state, events: filteredEvents });
						setState((prevState) => { return { ...prevState, events: filteredEvents } })
					}
				}
				else {
					// setState({
					// 	...state,
					// 	events: response.events,
					// 	totalSize: response.total_number,
					// 	page: (response.page_number) ? response.page_number * 1 : page,
					// 	sizePerPage: sizePerPage
					// });
					setState((prevState) => {
						return {
							...prevState,
							events: response.events,
							totalSize: response.total_number,
							page: (response.page_number) ? response.page_number * 1 : page,
							sizePerPage: sizePerPage
						}
					})
				}

				if (!response.events.length) {
					toastr.info('', 'Device does not have events');
				}

				if (callback && typeof callback === 'function') {
					callback();
				}

				if (showLoader) {
					toggleLoader(false);
				}
			})
			.catch((error) => {
				toggleLoader(false);

				console.log('!getEventsOfCompanyAndRange error: ', error.response, error);

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const getFilters = () => {
		const res = [];

		_.forOwn(state.filters, (value, key) => {
			if (!value) {
				res.push(key)
			}
		})

		return res.join(',');
	}

	const openLive = (event) => {
		event.preventDefault()

		const deviceId = activeTreeItem.device_id

		if (!activeTreeItem.online) {
			toastr.warning('', 'Device is offline')
			return
		} else if (activeTreeItem.disable_live_stream) {
			toastr.warning('', 'Live Stream is disabled')
			return
		}

		ReactGA.event({
			category: userRole,
			action: 'Live Stream',
			label: 'Open Live Stream'
		})

		const width = 660
		const height = 400
		const w = window
		const d = document
		const e = d.documentElement
		const g = d.getElementsByTagName('body')[0]
		const winWidth = w.innerWidth || e.clientWidth || g.clientWidth
		const winHeight = w.innerHeight || e.clientHeight || g.clientHeight
		const winX = (document.all) ? window.screenLeft : window.screenX
		const winY = (document.all) ? window.screenTop : window.screenY
		const left = ((winWidth - width) / 2) + winX
		const top = ((winHeight - height) / 2) + winY
		const windowSpecs = `toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=1,width=${width},height=${height},left=${left},top=${top}`
		const target = deviceId
		const win = window.open(`/live/video/${target}`, `${target}1`, windowSpecs);

		return win
	}

	const openClip = (event, row) => {
		event.preventDefault();
		if (!isMobileOnly) {
			props.openAdvancedPlayer(row);
		}
		else {
			const eventId = row.id;

			// Stores required params for the separate browser window to the local storage.
			const winOpen = {
				eventId,
				type: row.type,
				custom_event_type: row.custom_event_type,
				userRole: userRole,
				companyName: company.name,
				partnerName: company.partner,
				driverRecognition: company.driver_recognition,
			}
			localStorage.setItem('winOpen', JSON.stringify(winOpen));

			ReactGA.event({
				category: userRole,
				action: 'Open Event Video',
				label: row.type
			})

			const width = 1200
			const height = 700
			const w = window
			const d = document
			const e = d.documentElement
			const g = d.getElementsByTagName('body')[0]
			const winWidth = w.innerWidth || e.clientWidth || g.clientWidth
			const winHeight = w.innerHeight || e.clientHeight || g.clientHeight
			const winX = (document.all) ? window.screenLeft : window.screenX
			const winY = (document.all) ? window.screenTop : window.screenY
			const left = ((winWidth - width) / 2) + winX
			const top = ((winHeight - height) / 2) + winY
			const windowSpecs = `toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=1,width=${width},height=${height},left=${left},top=${top}`
			const target = eventId
			const win = window.open(`/event/video/${target}`, `${target}1`, windowSpecs);

			return win
		}
	}

	const openTripsHistory = (event) => {
		// debugger
		event.preventDefault();
		setShowTripsHistory(!showTripsHistory)
		ReactGA.event({
			category: userRole,
			action: 'Trip Replay',
			label: 'Open Trip Replay',
		})
	}

	const openVideoRequest = () => {
		setState({ ...state, showVideoRequest: true });
		ReactGA.event({
			category: userRole,
			action: 'Custom Video Request',
			label: 'Open Custom Video Request'
		})
	}

	const openManageVehicles = () => {
		const params = {
			name: company.name,
			partner: company.partner,
		}

		ReactGA.event({
			category: userRole,
			action: 'Manage Vehicles',
			label: 'Open Manage Vehicles'
		})

		browserHistory.push({ pathname: '/managevehicles/edit', state: { id: activeTreeItem.device_id, company: params, type: 'vehicle_sidebar', last_disconnected_ts: activeTreeItem.last_disconnected_ts } })

	}

	const onCloseVideoRequest = () => {
		ReactGA.event({
			category: userRole,
			action: 'Custom Video Request',
			label: 'Close Custom Video Request'
		})
		// setState({ ...state, showVideoRequest: false })
		setState((prevState) => { return { ...prevState, showVideoRequest: false } })
	}

	const onSaveVideoRequest = (data) => {
		const paramRequestedEventIDs = [...state.requestedEventIDs, data.event_id]
		ReactGA.event({
			category: userRole,
			action: 'Custom Video Request',
			label: 'Submit Custom Video Request'
		})
		// setState({ ...state, showVideoRequest: false });
		// setState({ ...state, paramRequestedEventIDs });
		setState((prevState) => { return { ...prevState, showVideoRequest: false, paramRequestedEventIDs } })

		getAvailableDates(() => {
			if (state.availableDates.length) {
				// setState({ ...state, eventDate: data.event_ts })
				setState((prevState) => { return { ...prevState, eventDate: data.event_ts } })
				getFleetEvents(
					1,
					state.sizePerPage,
					true,
					data.event_ts
				)
			} else {
				toastr.info('', 'Device does not have events')
			}
		})

		if (interval) {
			clearInterval(interval)
			setIntervalState(null);
		}
		setIntervalState(setInterval(() => {
			if (!state.requestedEventIDs.length) {
				clearInterval(interval)
				setIntervalState(null);
			} else {
				console.log('INTERVAL')
				getFleetEvents(state.page, state.sizePerPage, false, null, null, null, state.requestedEventIDs.join(','))
			}
		}, 5000));
	}

	const clearTimer = () => {
		if (interval) {
			clearInterval(interval)
			setIntervalState(null);
		}
	}

	const liveVideoAccess = () => {
		const userPermissions = user.permissions

		if (!company.company_data.live_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
			return false
		}
		// FWSD-4552
		if (['custom_user', 'custom_partner'].includes(userRole) && !userPermissions.find((item) => item.perm_category_id === 14 && item.a_view)) {
			return false
		}

		return true
	}

	const editVehicleAccess = () => {
		if (['custom_user', 'custom_partner'].includes(user.roles[0]) && !_.find(user.permissions, { perm_category_id: 5, a_view: true })) {
			return false
		}

		return true
	}

	const setPropStates = (states, callback = null) => {
		setState({ ...state, ...states });
		if (typeof callback === 'function') {
			callback();
		}
	}

	let menuItemWidth = 3
	if (!liveVideoAccess() && !editVehicleAccess()) {
		menuItemWidth = 6
	}
	else if (!liveVideoAccess() || !editVehicleAccess()) {
		menuItemWidth = 4
	}

	if (!activeTreeItem) {
		return <div>No data...</div>
	}

	const EventVideoRequestModalMemo = useMemo(() =>
	(<EventVideoRequestModal
		deviceSelection={false}
		device={activeTreeItem}
		onHide={onCloseVideoRequest}
		onSave={onSaveVideoRequest}
	/>), [activeTreeItem])

	// console.log('STATE VehicleSidebar state: ', state)
	// console.log('STATE VehicleSidebar state.eventDate: ', state.eventDate)

	return (
		<div className="sidebarContent">
			<div className="headerWrapper">
				<div className="title">
					{activeTreeItem.vehicle_name || activeTreeItem.device_id}
					{activeTreeItem.driver_name
						&& <span>{`   - ${activeTreeItem.driver_name}`}</span>}
				</div>
				<div className="header">
					<div className="row" style={{ margin: 'auto' }}>
						<div className="menu col-md-12 col-sm-12 col-xs-12">
							{liveVideoAccess() && (
								<div className="col-md-3 col-sm-3 col-xs-3">
									<div className={'menuItem' + ((activeTreeItem.online && !activeTreeItem.disable_live_stream) ? '' : ' disabled')} onClick={openLive} title='Live Stream'>
										<svg xmlns="http://www.w3.org/2000/svg" width="38.5" height="38.5" fill="currentColor" className="bi bi-camera-video" viewBox="0 0 16 16">
											<path fillRule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175l3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z" />
										</svg>
									</div>
								</div>
							)}
							<div className="col-md-3 col-sm-3 col-xs-3">
								<div className='menuItem' onClick={openTripsHistory} title='Route History'>
									<svg xmlns="http://www.w3.org/2000/svg" width="38.5" height="38.5" className={`menuItem ${showTripsHistory && 'active'}`} fill="currentColor" viewBox="0 0 446.012 446.012">
										<path d="M81.099,313.907c0-4.971,4.029-9,9-9h2.147c4.971,0,9,4.029,9,9s-4.029,9-9,9h-2.147  C85.128,322.907,81.099,318.878,81.099,313.907z M276.109,124.464c-12.208,4.125-20.412,15.533-20.412,28.39  c0,16.518,13.438,29.955,29.955,29.955h81.487c16.517,0,29.955-13.438,29.955-29.955c0-12.855-8.202-24.264-20.41-28.389  c-4.707-1.591-9.816,0.937-11.407,5.646c-1.591,4.709,0.937,9.816,5.646,11.407c4.888,1.651,8.171,6.207,8.171,11.336  c0,6.592-5.363,11.955-11.955,11.955h-81.487c-6.592,0-11.955-5.363-11.955-11.955c0-5.129,3.285-9.686,8.173-11.337  c4.709-1.591,7.237-6.698,5.646-11.407C285.926,125.4,280.818,122.875,276.109,124.464z M141.461,387.668  c-4.71-1.595-9.816,0.937-11.407,5.646c-1.591,4.709,0.937,9.815,5.646,11.406c4.888,1.651,8.172,6.206,8.172,11.335  c0,6.593-5.362,11.956-11.954,11.956H50.43c-6.592,0-11.955-5.363-11.955-11.956c0-5.128,3.285-9.684,8.174-11.336  c4.709-1.591,7.237-6.698,5.646-11.407s-6.697-7.234-11.407-5.646c-12.209,4.125-20.412,15.534-20.412,28.389  c0,16.518,13.438,29.956,29.955,29.956h81.488c16.517,0,29.954-13.438,29.954-29.956C161.872,403.2,153.669,391.792,141.461,387.668  z M66.446,380.509c-16.037-31.518-25.976-53.652-25.976-66.603c0-27.957,22.746-50.702,50.704-50.702  c27.957,0,50.702,22.745,50.702,50.702c0,12.96-9.938,35.092-25.974,66.602c0,0-5.735,11.321-6.022,11.923  c-2.314,4.852-6.621,13.882-18.707,13.882c-12.086,0-16.394-9.029-18.708-13.881C72.18,391.83,66.446,380.509,66.446,380.509z   M58.47,313.906c0,11.236,16.831,44.313,24.018,58.438c0,0,7.65,15.326,8.165,15.938c0.319,0.458,0.804,0.209,1.041,0.001  c0.515-0.612,1.364-2.394,1.94-3.602c0.344-0.721,6.227-12.338,6.227-12.338c7.187-14.121,24.016-47.191,24.016-58.438  c0-18.032-14.67-32.702-32.702-32.702C73.141,281.204,58.47,295.874,58.47,313.906z M425.536,9v64.51c0,4.971-4.029,9-9,9h-81.141  v41.483h7.128c4.971,0,9,4.029,9,9s-4.029,9-9,9h-32.255c-4.971,0-9-4.029-9-9s4.029-9,9-9h7.127V73.701  c-0.001-0.064-0.002-0.127-0.002-0.191s0-0.128,0.002-0.191V9.191c-0.001-0.064-0.002-0.127-0.002-0.191c0-4.971,4.029-9,9-9h90.143  C421.507,0,425.536,4.029,425.536,9z M407.536,18h-72.141v46.51h72.141V18z M352.028,214.007H93.985  c-30.608,0-55.509-24.902-55.509-55.511s24.901-55.51,55.509-55.51h181.463c4.971,0,9-4.029,9-9s-4.029-9-9-9H93.985  c-40.533,0-73.509,32.977-73.509,73.51c0,40.534,32.976,73.511,73.509,73.511h258.043c30.607,0,55.508,24.901,55.508,55.51  s-24.901,55.51-55.508,55.51H170.564c-4.971,0-9,4.029-9,9s4.029,9,9,9h181.464c40.533,0,73.508-32.977,73.508-73.51  S392.561,214.007,352.028,214.007z" />
									</svg>
									{showTripsHistory && <div className="stopTitle">Stop</div>}
								</div>
							</div>
							<div className="col-md-3 col-sm-3 col-xs-3">
								<div className='menuItem' onClick={openVideoRequest} title='Custom Video Request'>
									<svg xmlns="http://www.w3.org/2000/svg" width="38.5" height="38.5" fill="currentColor" className="bi bi-file-earmark-play menuItem" viewBox="0 0 16 16">
										<path d="M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z" />
										<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
									</svg>
								</div>
							</div>
							{editVehicleAccess() && (
								<div className="col-md-3 col-sm-3 col-xs-3">
									<div className='menuItem' onClick={openManageVehicles} title='Edit Vehicle'>
										<svg xmlns="http://www.w3.org/2000/svg" width="38.5" height="38.5" fill="currentColor" className="bi bi-gear menuItem" viewBox="0 0 16 16">
											<path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
											<path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
										</svg>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

			{showTripsHistory
				? (
					<TripsGrid
						_map={_map}
						eventDate={state.eventDate}
						activeTreeItem={activeTreeItem}
						setPropStates={setPropStates}
						onClickPlayback={onClickPlayback}
					/>
				)
				: (
					<div>
						<div className="date date-container-mobile">
							<AvailableDatesNav
								eventDate={state.eventDate}
								availableDates={state.availableDates}
								sizePerPage={state.sizePerPage}
								setPropStates={setPropStates}
								getFleetEvents={getFleetEvents}
								clearTimer={clearTimer}
							/>
						</div>
						<EventsTable
							events={state.events}
							filters={state.filters}
							page={state.page}
							sizePerPage={state.sizePerPage}
							totalSize={state.totalSize}
							openClip={openClip}
							getFleetEvents={getFleetEvents}
							setPropStates={setPropStates}
						/>
					</div>
				)
			}

			{state.showVideoRequest && (EventVideoRequestModalMemo)}
		</div>
	)
}

VehicleSidebar.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	showTripsHistory: PropTypes.bool.isRequired,
	activeTreeItem: PropTypes.object,
	setShowTripsHistory: PropTypes.func.isRequired
};

const mapStateToProps = ({ user, company, dashboardData }) => ({
	user: user.user,
	company: company.company,
	showTripsHistory: dashboardData.showTripsHistory
});

const mapDispatchToProps = dispatch => ({
	setShowTripsHistory: (state) => {
		dispatch({ type: 'SET_SHOW_TRIP_HISTORY', payload: state });
	},
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSidebar);
